// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file for a fulfillment order to the remote API.
 *
 * @param id - The ID of the fulfillment order for which to upload the file.
 * @param file - The file to upload.
 */
export async function uploadFulfillmentFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'FULFILLMENT_ORDER_FILE',
    isPublic: false,
    entityId: id,
  });
}
